export default __webpack_public_path__ + "static/media/small-GitHub-Mark.6e70274f.svg";